import { lazy } from "react";

const NotificationsV2 = lazy(() => import("features/Notification/v2"));

export const NOTIFICATION_PATH = "/notification";

// V2 Routes
export const NOTIFICATION_V2_PATH = "/notification";

export const notificationRoutesV2 = [
  {
    path: NOTIFICATION_V2_PATH,
    component: <NotificationsV2 />,
  },
];
